import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=5bc2829c&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"
import style0 from "./Schedules.vue?vue&type=style&index=0&id=5bc2829c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2829c",
  null
  
)

export default component.exports